import { GrowthBook } from "@growthbook/growthbook";
import { environment } from "environments/environment";

export const growthbook = new GrowthBook({
    apiHost: "https://api.growthbook.bankme.tech",
    clientKey: environment.vars.growthbook.clientKey,
    enableDevMode: !environment.production,
    decryptionKey: environment.vars.growthbook.decryptionKey || "bankme_tech",
});

export interface GrowthBookAttributes {
    id: string;
    companyId: string;
    email: string;
    minibankId: string;
}

export const setGrowthBookAttributes = (attributes: GrowthBookAttributes): void => {
    growthbook.setAttributes(attributes);
};

export const loadGrowthBookFeatures = async (): Promise<boolean> => {
    try {
        await growthbook.loadFeatures();
        return true;
    } catch (error) {
        console.error("Erro ao carregar features do GrowthBook:", error);
        return false;
    }
};

export default growthbook;
